import React, {
    useEffect,
    useState
} from "react";
import "./CubeSatLab.css";


const API =
    "/api";


export default function CubeSatLab() {

    const [telemetry, setTelemetry] =
        useState(null);

    const [error, setError] =
        useState("");

    const [loading, setLoading] =
        useState(true);


    // =================================================
    // Get telemetry
    // =================================================

    const loadTelemetry = async () => {

        try {

            const response =
                await fetch(
                    `${API}/cubesat/telemetry`
                );

            if (!response.ok) {
                throw new Error(
                    "Unable to get telemetry"
                );
            }

            const data =
                await response.json();

            setTelemetry(data);

            setError("");

        } catch (err) {

            setError(
                err.message
            );

        } finally {

            setLoading(false);
        }
    };


    // =================================================
    // Poll telemetry
    // =================================================

    useEffect(() => {

        loadTelemetry();

        const timer =
            setInterval(
                loadTelemetry,
                1000
            );

        return () =>
            clearInterval(timer);

    }, []);


    // =================================================
    // Send command
    // =================================================

    const command = async (
        url,
        body = {}
    ) => {

        try {

            const response =
                await fetch(
                    `${API}${url}`,
                    {
                        method: "POST",

                        headers: {
                            "Content-Type":
                                "application/json"
                        },

                        body:
                            JSON.stringify(body)
                    }
                );

            const data =
                await response.json();

            if (!response.ok) {

                throw new Error(
                    data.error ||
                    "Command failed"
                );
            }

            await loadTelemetry();

        } catch (err) {

            setError(
                err.message
            );
        }
    };


    if (loading) {

        return (
            <div>
                Connecting to CubeSat...
            </div>
        );
    }


    if (!telemetry) {

        return (
            <div>
                No telemetry available
            </div>
        );
    }


    return (

        <div className="cubesat-lab">

            <h1>
                STEMX365 CubeSat Mission Control
            </h1>


            {error && (

                <div className="error">
                    {error}
                </div>

            )}


            {/* =========================================
                Spacecraft status
            ========================================= */}

            <div className="dashboard">

                <div className="card">

                    <h2>
                        Spacecraft
                    </h2>

                    <p>
                        Mode:
                        <strong>
                            {" "}
                            {telemetry.mode}
                        </strong>
                    </p>

                    <p>
                        Communication:
                        {" "}
                        {telemetry.communication
                            ? "CONNECTED"
                            : "LOST"}
                    </p>

                    <p>
                        GPS:
                        {" "}
                        {telemetry.gps_fix
                            ? "LOCKED"
                            : "NO FIX"}
                    </p>

                </div>


                {/* =====================================
                    Power
                ===================================== */}

                <div className="card">

                    <h2>
                        Power
                    </h2>

                    <p>
                        Battery:
                        <strong>
                            {" "}
                            {telemetry.battery}%
                        </strong>
                    </p>

                    <p>
                        Solar:
                        {" "}
                        {telemetry.solar_power} W
                    </p>

                    <p>
                        Consumption:
                        {" "}
                        {telemetry.power_consumption} W
                    </p>

                </div>


                {/* =====================================
                    Environment
                ===================================== */}

                <div className="card">

                    <h2>
                        Environment
                    </h2>

                    <p>
                        Temperature:
                        {" "}
                        {telemetry.temperature}
                        °C
                    </p>

                    <p>
                        CPU:
                        {" "}
                        {telemetry.system.cpu}%
                    </p>

                    <p>
                        Memory:
                        {" "}
                        {telemetry.system.memory}%
                    </p>

                </div>


                {/* =====================================
                    Position
                ===================================== */}

                <div className="card">

                    <h2>
                        Orbit
                    </h2>

                    <p>
                        Latitude:
                        {" "}
                        {telemetry.position.latitude}
                    </p>

                    <p>
                        Longitude:
                        {" "}
                        {telemetry.position.longitude}
                    </p>

                    <p>
                        Altitude:
                        {" "}
                        {telemetry.position.altitude}
                        {" "}km
                    </p>

                </div>


                {/* =====================================
                    Attitude
                ===================================== */}

                <div className="card">

                    <h2>
                        Attitude
                    </h2>

                    <p>
                        Roll:
                        {" "}
                        {telemetry.attitude.roll}°
                    </p>

                    <p>
                        Pitch:
                        {" "}
                        {telemetry.attitude.pitch}°
                    </p>

                    <p>
                        Yaw:
                        {" "}
                        {telemetry.attitude.yaw}°
                    </p>

                </div>


                {/* =====================================
                    Payload
                ===================================== */}

                <div className="card">

                    <h2>
                        Payload
                    </h2>

                    <p>
                        Status:
                        {" "}
                        {telemetry.payload.enabled
                            ? "ENABLED"
                            : "DISABLED"}
                    </p>

                    <p>
                        Images:
                        {" "}
                        {telemetry.payload.images}
                    </p>

                </div>

            </div>


            {/* =========================================
                Commands
            ========================================= */}

            <div className="commands">

                <h2>
                    Mission Commands
                </h2>


                <button
                    onClick={() =>
                        command(
                            "/cubesat/mode",
                            {
                                mode:
                                    "NOMINAL"
                            }
                        )
                    }
                >
                    NOMINAL
                </button>


                <button
                    onClick={() =>
                        command(
                            "/cubesat/mode",
                            {
                                mode:
                                    "SAFE"
                            }
                        )
                    }
                >
                    SAFE MODE
                </button>


                <button
                    onClick={() =>
                        command(
                            "/cubesat/mode",
                            {
                                mode:
                                    "LOW_POWER"
                            }
                        )
                    }
                >
                    LOW POWER
                </button>


                <button
                    onClick={() =>
                        command(
                            "/cubesat/payload/enable"
                        )
                    }
                >
                    ENABLE PAYLOAD
                </button>


                <button
                    onClick={() =>
                        command(
                            "/cubesat/payload/disable"
                        )
                    }
                >
                    DISABLE PAYLOAD
                </button>


                <button
                    onClick={() =>
                        command(
                            "/cubesat/payload/capture"
                        )
                    }
                >
                    CAPTURE IMAGE
                </button>


                <button
                    onClick={() =>
                        command(
                            "/cubesat/reset"
                        )
                    }
                >
                    RESET
                </button>

            </div>


            {/* =========================================
                Faults
            ========================================= */}

            <div className="faults">

                <h2>
                    Spacecraft Faults
                </h2>

                {telemetry.faults.length === 0
                    ? (
                        <p>
                            No faults detected
                        </p>
                    )
                    : (
                        telemetry.faults.map(
                            fault => (
                                <div
                                    key={fault}
                                    className="fault"
                                >
                                    ⚠ {fault}
                                </div>
                            )
                        )
                    )}

            </div>

        </div>
    );
}